import { Link } from '@remix-run/react'
import { useState } from 'react'
import Rating from '#app/components/rating'
import { api } from '#app/utils/api'
import { type CleaningProvider } from '#app/utils/api/types'
import { useRandomProviders } from '../../hooks/use-random-providers'

export const AvailableCleaningProviders = () => {
	const { data, status } = useRandomProviders()

	return (
		<div className="w-96 max-w-full">
			<div className="flex max-w-full flex-col gap-4 rounded-[10px] border-[#36415B4D] xs:min-w-[320px] lg:border lg:bg-white lg:p-4">
				<h1 className="text-lg font-semibold leading-loose text-headings">
					Dostupné paní na úklid
				</h1>
				{status === 'loading' ? (
					<>
						<div className="animate-pulse rounded-lg border border-[#EAF0FF] bg-white p-4">
							<div className="h-10 w-10 rounded-2xl bg-slate-400" />
						</div>
						<div className="animate-pulse rounded-lg border border-[#EAF0FF] bg-white p-4">
							<div className="h-10 w-10 rounded-2xl bg-slate-400" />
						</div>
						<div className="animate-pulse rounded-lg border border-[#EAF0FF] bg-white p-4">
							<div className="h-10 w-10 rounded-2xl bg-slate-400" />
						</div>
						<div className="animate-pulse rounded-lg border border-[#EAF0FF] bg-white p-4">
							<div className="h-10 w-10 rounded-2xl bg-slate-400" />
						</div>
						<div className="animate-pulse rounded-lg border border-[#EAF0FF] bg-white p-4">
							<div className="h-10 w-10 rounded-2xl bg-slate-400" />
						</div>
					</>
				) : (
					(data ?? []).map(provider => (
						<ProviderListItem key={provider.businessName} provider={provider} />
					))
				)}
			</div>
			<div className="mt-4 rounded-[10px] border border-[#36415B4D] bg-white p-4">
				<div className="text-sm font-semibold leading-tight text-blue-800">
					Potřebujete poradit?
				</div>
				<div className="self-stretch text-sm leading-tight text-zinc-800">
					Pokud máte jakékoli dotazy k objednávce, neváhejte využít náš chat v
					pravém dolním rohu obrazovky.
				</div>
			</div>
		</div>
	)
}

const ProviderListItem = ({ provider }: { provider: CleaningProvider }) => {
	const [imgSrc, setImgSrc] = useState(api.getProviderImageUrl(provider._id))

	return (
		<Link
			prefetch="intent"
			to={`/dashboard/provider/${provider._id}`}
			className="flex items-center gap-3 rounded-lg border border-[#EAF0FF] bg-white p-4"
			key={String(provider.businessName) + String(provider.rating)}
		>
			<div className="h-10 w-10 rounded-2xl bg-slate-400">
				<img
					width={52}
					height={52}
					src={imgSrc}
					alt={provider.businessName}
					onError={() => setImgSrc('/img/cleaning-providers/default.png')}
					className="aspect-square rounded-2xl object-cover"
				/>
			</div>
			<div className="flex flex-col">
				<span>{provider.businessName}</span>
				<Rating rating={provider.rating?.average || 0} />
			</div>
		</Link>
	)
}
